import invariant from 'tiny-invariant';

import {
  GraphChartType,
  GraphChartTypeOption,
} from 'business/data-analysis/pages/graph/components/chart/types';
import { GraphPageState } from 'business/data-analysis/pages/graph/hooks/graph-context/types';
import { DisplayType } from 'business/data-analysis/pages/graph/types';
import { getNewGraphNumber } from 'business/data-analysis/services/get-new-graph-number';

export const updateGraph = (
  graphSet: GraphPageState,
  graphId: string,
  update: {
    title?: string;
    displayType?: DisplayType;
    chartType?: GraphChartTypeOption;
  },
): GraphPageState => {
  const graphs = graphSet.structure.graphs;

  const graphToModify = graphs.get(graphId);
  invariant(graphToModify, 'Trying to update a non-existing graph');

  if (update.title) {
    graphToModify.title = update.title;
    // Set to `-1` to keep the lowest value available for next graphs
    graphToModify.graphNumber =
      update.title === '' ? getNewGraphNumber(Array.from(graphs.values())) : -1;
  }

  graphToModify.displayType = update?.displayType ?? graphToModify.displayType;

  graphToModify.parameters.forEach((parameter) => {
    parameter.chartType =
      update.chartType && update.chartType !== GraphChartType.CUSTOM
        ? update.chartType
        : parameter.chartType;
  });

  graphToModify.chartType = update.chartType ?? graphToModify.chartType;

  graphs.set(graphId, graphToModify);

  return {
    ...graphSet,
    structure: {
      ...graphSet.structure,
      graphs,
    },
  };
};
